module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp5-4874df19b7d60daa879e166376912dde.jpg";